import { closePopup, openPopup } from '@/popups';
import Swiper, { EffectFade, Navigation, Pagination } from 'swiper';
import SwiperCore from 'swiper';
import 'vendors/unitegallery';

export class EventPage {
  init() {
    this.headProgress();
    this.headSpeedometer();
    this.headSponsors();
    this.tabs();
    this.registerHall();
    this.lectorSlider();
    this.reviewSlider();
    this.gallerySlider();
    this.galleryVideo();
  }

  headProgress() {
    const $progress = $('.event-head-progress');
    if (!$progress || $progress.length === 0) return;
    $progress.each((i, el) => {
      const $el = $(el);

      const $bar = $el.find('.event-head-progress-bar');
      const $filled = $el.find('.event-head-progress-bar-filled');
      const min = $bar.data('min');
      const max = $bar.data('max');
      const value = $bar.data('value');

      const percent = Math.round((value / (max - min)) * 100);
      $filled.css({ width: `${100 - percent}%` });
      $el.find('.event-head-progress-value .percent').text(`${percent}%`);
    });
  }

  headSpeedometer() {
    const $speedometer = $('.event-head-speedometer-graphic');
    if (!$speedometer || $speedometer.length === 0) return;
    const min = $speedometer.data('min');
    const max = $speedometer.data('max');
    const value = $speedometer.data('value');
    const $active = $speedometer.find('.event-head-speedometer-active');

    const percent = Math.round((value / (max - min)) * 100);
    const rotate = Math.round((percent * 180) / 100) - 135;

    $speedometer.find('.event-head-speedometer-value').text(`${percent}%`);

    $active.css({ transform: `rotate(${rotate}deg)` });
  }

  headSponsors() {
    const $sponsors = $('.event-head-sponsors');
    if (!$sponsors || $sponsors.length === 0) return;

    const topHeight = $('.event-head-top').height();
    const titleHeight = $('.event-head-title').height();
    const $open = $('.open-sponsors');
    const $close = $('.event-head-sponsors-close');
    let padding = 30;

    if ($(window).width() < 768) {
      padding = 100;
    }

    $sponsors.css({ top: `${topHeight + titleHeight + padding}px` });
    $open.on('click', (e) => {
      e.preventDefault();
      $sponsors.addClass('show');
      $sponsors.on('click.sponsors', (e) => {
        e.preventDefault();

        if (!$(e.target).closest('.event-head-sponsors-content').length) {
          $sponsors.removeClass('show');
          $sponsors.off('click.sponsors');
        }
      });
    });

    $close.on('click', (e) => {
      e.preventDefault();
      $sponsors.removeClass('show');
    });
  }

  tabs() {
    const $navigation = $('.event-tabs-navigation');
    if (!$navigation || $navigation.length === 0) return;
    $navigation.find('a').on('click', (e) => {
      e.preventDefault();
      const $t = $(e.currentTarget);
      $t.addClass('active').parent().siblings().find('a').removeClass('active');
      $($t.attr('href'))
        .addClass('active')
        .siblings('.event-tabs-pane')
        .removeClass('active');
    });
  }

  registerHall() {
    $('.button-event-register-hall').on('click', (e) => {
      e.preventDefault();
      closePopup($('#event-register'));
      openPopup($('#event-register-hall'));
    });
  }

  lectorSlider() {
    const $slider = $('.event-lector-slider');
    if (!$slider || $slider.length === 0) return;
    SwiperCore.use([Navigation]);

    const swiper = new Swiper('.event-lector-slider', {
      navigation: {
        prevEl: '.event-lector-slider-prev',
        nextEl: '.event-lector-slider-next',
      },
    });
  }

  reviewSlider() {
    const $slider = $('.event-review-slider');
    if (!$slider || $slider.length === 0) return;
    SwiperCore.use([Navigation, Pagination]);

    const swiper = new Swiper('.event-review-slider', {
      navigation: {
        prevEl: '.event-review-slider-prev',
        nextEl: '.event-review-slider-next',
      },
      pagination: {
        el: '.event-review-slider-dots',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
    });
  }

  gallerySlider() {
    const $slider = $('.event-galley-slider');
    if (!$slider || $slider.length === 0) return;
    SwiperCore.use([Navigation, EffectFade, Pagination]);

    const swiper = new Swiper('.event-galley-slider', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        0: {
          pagination: {
            el: '.event-galley-slider-mobile-dots',
            clickable: true,
          },
          navigation: {
            prevEl: '.event-galley-slider-mobile-prev',
            nextEl: '.event-galley-slider-mobile-next',
          },
        },
        768: {
          pagination: false,
          navigation: {
            prevEl: '.event-galley-slider-prev',
            nextEl: '.event-galley-slider-next',
          },
        },
      },
    });
  }

  galleryVideo() {
    const $gallery = jQuery('#event-gallery-video');
    if (!$gallery || $gallery.length === 0) return;
    $gallery.unitegallery({
      gallery_theme: 'video',
      theme_skin: 'right-no-thumb',
    });
  }
}
